import { render, staticRenderFns } from "./Check.vue?vue&type=template&id=3975cf4d&scoped=true&slot-scope=scope&"
import script from "./Check.vue?vue&type=script&lang=js&"
export * from "./Check.vue?vue&type=script&lang=js&"
import style0 from "./Check.vue?vue&type=style&index=0&id=3975cf4d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3975cf4d",
  null
  
)

export default component.exports